import React from 'react';

import { applicationTitles } from '../../localization/en-us/applicationTitles';

import classes from './Title.module.css';

const RulesTitle = () => (
    <div className={classes.TitleBox}>
        <img src="/assets/images/rulesColorIcon.svg" alt="" />
        <p>{applicationTitles.ruleBuilder}</p>
    </div>
);

export default RulesTitle;
